import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import { map, catchError, Observable } from 'rxjs';
import { RtvUnitTrainTrip, RtvUnitTrainTripAdapter } from '@bds/railtrac-models';
import { ApiErrorHandlerService } from '@bds/helpers';

@Injectable({
    providedIn: 'root',
})
export class RtUnitTrainSummaryGridService {
    private readonly baseUrl: string;
    private readonly odataUrl: string;

    constructor(
        private http: HttpClient,
        private adapter: RtvUnitTrainTripAdapter,
        private apiErrorHandler: ApiErrorHandlerService,
        @Inject('BASE_API_URL') private apibaseUrl: string,
        @Inject('BASE_ODATA_URL') private odatabaseUrl: string,
    ) {
        this.baseUrl = this.apibaseUrl;
        this.odataUrl = this.odatabaseUrl;
    }

    getODataStore(): DataSource {
        return new DataSource({
            store: new ODataStore({
                version: 4,
                url: this.odataUrl + 'unitTrain',
            }),
            paginate: true,
            pageSize: 20,
        });
    }

    getUnitTrainDetails(unitTrainId: string): Observable<RtvUnitTrainTrip[]> {
        return this.http.get<RtvUnitTrainTrip[]>(`${this.odataUrl}unitTrain(${unitTrainId})`).pipe(
            map((data) => {
                if (Array.isArray(data)) {
                    const unitTrainDetails = data?.map((m) => this.adapter.adapt(m));
                    return unitTrainDetails.length > 0 ? unitTrainDetails : [];
                } else if (data) {
                    return [this.adapter.adapt(data)];
                } else {
                    return [];
                }
            }),
            catchError((err) => this.apiErrorHandler.handleError(err as HttpErrorResponse)),
        );
    }
}
